/* ============================================================================
   PRESSROOM — TICKER davranisi (FAZ 2 Parti 1, spec 3.2)
   <pressroom-ticker> web component. Saf CSS marquee'ye scroll-velocity bagi ekler:
   hizli scroll -> --pr-ticker-vel artar (serit hizlanir, "pres devri"). Hover'da
   CSS zaten yavaslatir; JS yalniz velocity carpanini yazar.

   Kurallar (CLAUDE.md + spec):
   - Hardcoded yok: boost miktari data-velocity-boost'tan, durations CSS token'dan.
   - reduced-motion: hicbir sey kurma (CSS zaten marquee'yi durdurur).
   - Mobil / touch (pointer: coarse): velocity bagi KAPALI (sabit hiz).
   - requestAnimationFrame throttle; passive scroll listener; viewport disinda durur.
   ============================================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE_POINTER = window.matchMedia('(pointer: fine)').matches;
  var DESKTOP = window.matchMedia('(min-width: 990px)').matches;

  var VEL_MIN = 1; // normal hiz carpani
  var HOVER_VEL = 0.5; // hover'da yavaslama hedefi (spec: hover slows)
  var DECAY = 0.85; // velocity her frame hedefe doner

  if (!('customElements' in window)) return;

  customElements.define('pressroom-ticker', class extends HTMLElement {
    connectedCallback() {
      this._section = this.querySelector('.pr-ticker');
      if (!this._section) return;

      // Mobil + reduced-motion + touch: velocity bagi yok (CSS sabit hiz / durur).
      this._velocityEnabled =
        !REDUCED && FINE_POINTER && DESKTOP &&
        (parseFloat(this._section.getAttribute('data-velocity-boost')) || 0) > 0;

      if (!this._velocityEnabled) return;

      this._boost = parseFloat(this._section.getAttribute('data-velocity-boost')) || 6;
      this._lastY = window.scrollY || window.pageYOffset;
      this._vel = VEL_MIN;
      this._ticking = false;
      this._inView = true;
      this._hover = false;

      this._onScroll = this._onScroll.bind(this);
      this._frame = this._frame.bind(this);
      this._onEnter = function () { this._hover = true; }.bind(this);
      this._onLeave = function () { this._hover = false; }.bind(this);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      // JS inline --pr-ticker-vel CSS :hover'i ezdiginden hover'i burada yonet.
      this._section.addEventListener('pointerenter', this._onEnter);
      this._section.addEventListener('pointerleave', this._onLeave);

      // Viewport disinda velocity hesabini durdur (perf).
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (entries) {
          this._inView = entries[0].isIntersecting;
        }.bind(this), { threshold: 0 });
        this._io.observe(this._section);
      }

      this._frame();
    }

    disconnectedCallback() {
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onEnter) this._section.removeEventListener('pointerenter', this._onEnter);
      if (this._onLeave) this._section.removeEventListener('pointerleave', this._onLeave);
      if (this._io) this._io.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      var y = window.scrollY || window.pageYOffset;
      var delta = Math.abs(y - this._lastY);
      this._lastY = y;
      // delta px/frame -> carpan. boost ile olcekle, makul tavan.
      var target = VEL_MIN + Math.min(delta / 40, 1) * this._boost;
      if (target > this._vel) this._vel = target;
      this._ticking = false;
    }

    _frame() {
      this._raf = requestAnimationFrame(this._frame);
      if (!this._inView) return;
      // Hedef: hover'da yavas, normalde scroll-boost'tan sonra 1'e doner.
      var target = this._hover ? HOVER_VEL : VEL_MIN;
      this._vel = target + (this._vel - target) * DECAY;
      if (Math.abs(this._vel - target) < 0.01) this._vel = target;
      this._section.style.setProperty('--pr-ticker-vel', this._vel.toFixed(3));
    }
  });
})();
